import {SearchCriteriaConfig} from "../../../common/search-criteria/type/search-criteria.type";

export const searchCriteria: SearchCriteriaConfig[] = [
    {
        key: 'mobile',
        label: 'Mobile Number',
        inputType: 'custom'
    },
    {
        key: 'joiningDate',
        label: 'Joining Date',
        inputType: 'date-range'
    },
];